import React from 'react';

export type Theme = 'light' | 'dark';
export interface UserData {
  csUserId: string;
  userId: string;
  userFirstName: string;
  userLastName: string;
  theme?: Theme;
  setTheme?: (theme: Theme) => void;
}

export const UserContext = React.createContext<Required<UserData>>({
  csUserId: '',
  userId: '',
  userFirstName: '',
  userLastName: '',
  theme: 'light',
  setTheme: () => {},
});
